module.exports = __webpack_public_path__ + "static/img/zierstaebe.4492f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat/zierstaebe.png
// module id = GcIL
// module chunks = 1